import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/models/IApiResponse';
import { Observable, catchError } from 'rxjs';
import { ConfigErrorHandler } from 'src/app/shared/config.errorhandler';

@Injectable({
  providedIn: 'root'
})
export class ForeignPermitPaymentsService {

  private baseURL = environment.apiURL;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json','Accept':'application/json' });

  constructor(
    private httpClient: HttpClient,
    private errorHandler: ConfigErrorHandler
  ) { }

  /**
   * Get vehicles pending foreign permit payment
   * @returns Array
   */
  getvehiclesPendingForeignPermitPayment(): Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/vehicles/pending-foreign-permit-payment`;

    return this.httpClient.get<ApiResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Save foreign permit payment
   * @param postData
   * @returns array
   */
  store(postData:any):Observable<any>{

    let apiURL:string=`${this.baseURL}/v1/post-foreign-permit-payment`;

    return this.httpClient.post(apiURL,postData, { headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }
}
